<template>
    <section class="mb-8">
        <h3
            class="text-base font-semibold text-slate-900 dark:text-slate-100 mb-3"
        >
            Current plan
        </h3>
        <div
            class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 py-3 border border-slate-200 dark:border-slate-700 rounded-lg shadow-sm"
        >
            <div>
                <template v-if="isEmployee">
                    <p
                        class="text-lg font-semibold text-slate-900 dark:text-slate-100"
                    >
                        <span class="text-10x-orange">
                            10x
                        </span>
                        <span class="font-black">
                            TRAVEL
                        </span>
                        <span class="text-10x-orange">
                            +
                        </span>
                    </p>
                    <span
                        v-if="isFoundersClubSubscriber"
                        class="inline-flex items-center gap-1 text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2.5 py-0.5 mt-1"
                    >
                        ★ Founders Club — Lifetime Price Lock
                    </span>
                    <p class="text-sm text-slate-500 dark:text-slate-400">
                        10xTravel employee — full access
                        included
                    </p>
                </template>
                <template v-else-if="isSubscribed">
                    <p
                        class="text-lg font-semibold text-slate-900 dark:text-slate-100"
                    >
                        <span class="text-10x-orange">
                            10x
                        </span>
                        <span class="font-black">
                            TRAVEL
                        </span>
                        <span class="text-10x-orange">
                            +
                        </span>
                    </p>
                    <span
                        v-if="isFoundersClubSubscriber"
                        class="inline-flex items-center gap-1 text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2.5 py-0.5 mt-1"
                    >
                        ★ Founders Club — Lifetime Price Lock
                    </span>
                    <p
                        class="text-sm text-slate-500 dark:text-slate-400"
                        v-if="subscriptionEnds"
                    >
                        Renewing {{ subscriptionEnds }} for
                        ${{ subscriptionPrice }}
                    </p>
                </template>
                <template v-else>
                    <p
                        class="text-lg font-semibold text-slate-900 dark:text-slate-100"
                    >
                        Basic
                    </p>
                    <p class="text-sm text-slate-500 dark:text-slate-400">
                        Free
                    </p>
                </template>
            </div>
            <div
                v-if="!isEmployee && isSubscribed && isMonthlySubscriber"
                class="flex items-center gap-3 w-full sm:w-auto"
            >
                <a
                    href="/checkout/switch-to-annual"
                    class="inline-flex items-center justify-center px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-slate-100 rounded shadow-sm hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-900/40 transition-colors flex-1 sm:flex-none whitespace-nowrap"
                >
                    Switch to annual
                </a>
            </div>
            <div
                v-if="
                    !isEmployee &&
                    isSubscribed &&
                    isYearlySubscriber &&
                    !isFoundersClubSubscriber
                "
                class="flex items-center gap-3 w-full sm:w-auto"
            >
                <a
                    href="/checkout/switch-to-monthly"
                    class="inline-flex items-center justify-center px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-slate-100 rounded shadow-sm hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-900/40 transition-colors flex-1 sm:flex-none whitespace-nowrap"
                >
                    Switch to monthly
                </a>
            </div>
            <div
                v-if="!isSubscribed"
                class="flex items-center gap-3 w-full sm:w-auto"
            >
                <a
                    href="/10xtravel-plus"
                    class="text-sm font-medium text-slate-900 dark:text-slate-100 hover:text-slate-700 dark:text-slate-200 transition-colors"
                >
                    Learn more
                </a>
                <a
                    href="/10xtravel-plus/upgrade"
                    class="inline-flex items-center justify-center px-4 py-2 bg-10x-orange text-white text-sm font-medium rounded shadow-sm hover:bg-orange-600 transition-colors flex-1 sm:flex-none"
                >
                    Upgrade
                </a>
            </div>
        </div>
    </section>
</template>

<script setup>
defineProps({
    isSubscribed: {
        type: Boolean,
        required: true,
    },
    isEmployee: {
        type: Boolean,
        required: true,
    },
    subscriptionEnds: {
        type: String,
        default: '',
    },
    subscriptionPrice: {
        type: String,
        default: '',
    },
    isMonthlySubscriber: {
        type: Boolean,
        default: false,
    },
    isYearlySubscriber: {
        type: Boolean,
        default: false,
    },
    isFoundersClubSubscriber: {
        type: Boolean,
        default: false,
    },
});
</script>
